import { BaseWebComponent } from "./webcomponent-base";
import { SidebarItemWebComponent } from "./webcomponent-sidebar-item";

export class SidebarSubItemWebComponent extends SidebarItemWebComponent {
    static webComponentName = "wc-sidebar-subitem";
    static observedAttributes = [
        // List of attributes to observe for changes
        "active",
        "href",
        "icon",
        "caption",
        "loaded"
    ];
    get href(): string {
        return this.getAttribute('href') || "#";
    }
    protected hasSubItems: boolean = false;

    constructor() {
        super();
    }
    protected init(): void {
        this.classList.add('loaded');
    }
   
    render(): void {
        if (!this.closest('.loaded')) {
            console.log("Parent sidebar item not loaded yet, skipping render");
            return;
        }
        const lines = [];
        lines.push(`<li class="sidebar-submenu-item">`);
        lines.push(`<a  
                class="sidebar-submenu-link ${this.active ? 'active' : ''}" 
                data-wc-tooltip="${this.caption}" 
                href="${this.href}">`);
        if (this.icon) {
            lines.push(`<i class="sidebar-nav-icon bi bi-${this.icon}"></i>`);
        }
        lines.push(`<span class="sidebar-nav-text">${this.caption}</span>`);
        lines.push(`</a>`);
        lines.push(`</li>`);
        this.innerHTML = lines.join('\n');
        this.setupTooltips();
    }
}

